import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ThemeProvider } from '@mui/material/styles';
import CustomTheme from '../../../styles/theme';
import './custom-date-field.scss';
import DniTooltip from '../dni-tooltip/dni-tooltip';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
const CustomDateField = (customDateFieldProps) => {
    const { label, showDniTooltip, onClickDniTooltip, onChange, error, errorMessage, onBlur } = customDateFieldProps;
    const inputRef = useRef(null);
    const [value, setValue] = useState('');
    const clickedToolTrip = () => onClickDniTooltip?.();
    const isMobile = useMediaQuery('(max-width:600px)');
    const isLeapYear = (year) => {
        return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
    };
    const isValidDate = (dateString) => {
        const [day, month, year] = dateString.split("/").map(Number);
        if (!day || !month || !year)
            return false;
        if (month < 1 || month > 12)
            return false;
        const daysInMonth = new Date(year, month, 0).getDate();
        if (day < 1 || day > daysInMonth)
            return false;
        if (month === 2 && day === 29 && !isLeapYear(year))
            return false;
        return true;
    };
    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Backspace' && isMobile) {
        }
    }, [isMobile]);
    const handleChange = (event) => {
        const inputEl = event.target;
        let cursorPos = inputEl.selectionStart ?? 0;
        let raw = inputEl.value.replace(/\D/g, "");
        let formatted = raw;
        if (raw.length > 2 && raw.length <= 4) {
            formatted = `${raw.slice(0, 2)}/${raw.slice(2)}`;
        }
        else if (raw.length > 4) {
            formatted = `${raw.slice(0, 2)}/${raw.slice(2, 4)}/${raw.slice(4, 8)}`;
        }
        setValue(formatted);
        requestAnimationFrame(() => {
            if (inputRef.current) {
                let newCursor = cursorPos;
                if (newCursor === 3 || newCursor === 6) {
                    if (event.nativeEvent instanceof InputEvent &&
                        event.nativeEvent.inputType === "deleteContentBackward") {
                        newCursor--;
                    }
                    else {
                        newCursor++;
                    }
                }
                inputRef.current.setSelectionRange(newCursor, newCursor);
            }
        });
        if (formatted.length === 10 && !isValidDate(formatted)) {
            onChange?.("");
        }
        else {
            onChange?.(formatted);
        }
    };
    const handleBlur = (event) => {
        const val = event.target.value;
        if (val && !isValidDate(val)) {
            onBlur?.({
                ...event,
                target: { ...event.target, value: "", name: label }
            });
        }
        else {
            onBlur?.(event);
        }
    };
    return (_jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, adapterLocale: 'es', children: _jsx(ThemeProvider, { theme: CustomTheme, children: _jsx(TextField, { inputRef: inputRef, className: 'custom-date-field', label: label, placeholder: "DD/MM/YYYY", value: value, onChange: handleChange, onBlur: handleBlur, onKeyDown: handleKeyDown, error: error, helperText: error ? errorMessage : "", inputProps: {
                    inputMode: "numeric",
                    pattern: "[0-9]*"
                }, InputLabelProps: {
                    sx: {
                        color: '#212429',
                        '&.Mui-focused': {
                            marginTop: '10px',
                            color: 'transparent',
                        },
                        '&.MuiFormLabel-filled': {
                            marginTop: '10px',
                            color: '#434A54',
                        },
                    },
                }, InputProps: {
                    sx: {
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        '& input': {
                            textTransform: 'lowercase !important',
                        },
                    },
                    endAdornment: showDniTooltip && (_jsxs(Box, { className: 'dni-tooltip', onClick: clickedToolTrip, children: [_jsx(DniTooltip, { className: 'dni-tooltip_desktop', showAnimation: true }), _jsx(DniTooltip, { className: 'dni-tooltip_mobile', showAnimation: true })] })),
                }, FormHelperTextProps: {
                    sx: {
                        color: "red"
                    }
                } }) }) }));
};
export default CustomDateField;
